import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Pill } from 'styles/CommonLayoutStyles';
import ZoneDetailsRow from '../ZoneDetailsRow';

const PrepaidTickets: React.FC<{
  testID: string;
  borderTop?: boolean;
  onListPress?: VoidFunction;
  ownedTickets?: number;
}> = ({ testID, borderTop, onListPress, ownedTickets = 0 }) => {
  const { t } = useTranslation();
  const OwnedTickets = useMemo(() => {
    if (ownedTickets) {
      return (
        <Pill py={3}>
          <Meta>
            {ownedTickets}{' '}
            {t('parking.prepaidTickets.owned', { count: ownedTickets })}
          </Meta>
        </Pill>
      );
    }
  }, [ownedTickets]);
  return (
    <ZoneDetailsRow
      borderTop={borderTop}
      title={t('parking.prepaidTickets.prepaidListLabel')}
      icon={<Icon name={'Services-Outlined'} />}
      testIDprefix={testID}
      onPress={onListPress}
      chevronColor={theme.colors.black}
      rightItem={OwnedTickets}
    />
  );
};

export default PrepaidTickets;
